import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import useVH from 'react-vh'

import { router } from '@/router'

import './app.module.scss'

import { store } from './store'

const App = () => {
  useVH()

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  )
}

export default App
